import { useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import arrow_up from '../../assets/icons/arrow-up.svg'
import { useUserContext } from '../../context/UserContext'
import { BeatLoader } from 'react-spinners'
import { FaUserCircle } from 'react-icons/fa'

function AdminProfile({ isOpen, setIsOpen }) {
  const navigate = useNavigate()
  const dropdownRef = useRef(null)
  const triggerRef = useRef(null)

  const {
    userData,
    isAuthenticated,
    onSignOutHandler,
    userLoading,
    refetchUser,
  } = useUserContext()

  useEffect(() => {
    if (isAuthenticated) {
      refetchUser()
    }
  }, [isAuthenticated, refetchUser])

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [setIsOpen])

  const fullName =
    (userData?.firstName && userData?.firstName.trim() !== ''
      ? userData?.firstName
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
      : '') +
    ' ' +
    (userData?.lastName && userData?.lastName.trim() !== ''
      ? userData?.lastName
      : 'Guest')

  return (
    <div className="relative w-full flex justify-end">
      {userLoading ? (
        <BeatLoader color={'#2b364b'} className="mt-5" />
      ) : (
        <div
          ref={triggerRef}
          className="flex items-center cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {userData?.photo ? (
            <img
              src={userData?.photo}
              alt="profile"
              className="w-10 h-10 rounded-full"
            />
          ) : (
            <FaUserCircle className="w-10 h-10" />
          )}
          <div className="px-[12px]">
            <div className="admin-profile-name capitalize">{fullName}</div>
            {/* <div className="team">Team A</div> */}
          </div>

          <img src={arrow_up} alt="arrow_up" />
        </div>
      )}

      {isOpen && (
        <div
          ref={dropdownRef}
          className="bg-white flex flex-col drop-shadow-xl w-[150px] max-h-[300px] overflow-y-auto rounded absolute top-10 border border-solid border-gray-300 z-10"
        >
          {userData?.type === 'Admin' &&
            userData?.brand !== 'saddlefitadmin' && (
              <>
                <Link
                  to="/profile"
                  className="no-underline logout-btn"
                  onClick={e => {
                    e.preventDefault()
                    setIsOpen(false)
                    e.stopPropagation()
                    navigate('/profile')
                  }}
                >
                  Update Profile
                </Link>
                <div className="h-px bg-gray-300"></div>
              </>
            )}
          <Link to="#" className="no-underline logout-btn" onClick={onSignOutHandler}>
            Logout
          </Link>
        </div>
      )}
    </div>
  )
}

export default AdminProfile
